import cloneDeep from 'lodash.clonedeep';

const BG_COLORS = ["#50C8B4", "#50C8B4", "#50C8B4"];

const INIT_OPTIONS = {
    chart: {
        height: 380,
        type: 'bar',
        stacked: false,
        toolbar: {
            show: false
        },
    },
    plotOptions: {
        bar: {
            dataLabels: {
                position: 'top', // top, center, bottom
            },
        }
    },
    dataLabels: {
        enabled: true,
        formatter: function (val) {
            return val;// + "%";
        },
        offsetY: -20,
        opacity:1,
        style: {
            fontSize: '14px',
            cssClass: 'column-label',
        }
    },
    colors: [/*"#2a76f4"*/],
    series: [/*{
        name: 'numero vendite',
        data: [67, 94, 10]        
    }*/],
    xaxis: {
        categories: [/*"Lug", "Ago", "Set"*/],
    },
    fill: {
        gradient: {
            enabled: false,
            shade: 'light',
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [50, 0, 100, 100]
        },
    },
    yaxis: {
        axisBorder: {
            show: true,
        },
        axisTicks: {
            show: true,
            
        },
        labels: {
            show: true,
            style: {
                colors: ['#000000'],
                fontSize: '10px',
                fontFamily: "'Work Sans', sans-serif",
            },
            formatter: function (val) {
                return val;// + "%";
            }
        },
        title: {
            text: '', //'conteggio record'
        }
    },
    title: {
        text: '', //'Mese di vendita',
        align: 'center',
        position: 'bottom',
        style: {
            fontSize:  '14px',
            fontFamily:  "'Work Sans', sans-serif",
            color: '#000',
            fontWeight:500
        }
    },
    grid: {
        row: {
            colors: ['#afb7d21a', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.2
        },
        borderColor: '#f1f3fa'
    },
    
}

class ABChartColumnCore {
    target;
    targetObj;
    options;
    plugin;

    constructor(target, options) {
        this.target = target;
        this.targetObj = this.getTarget(target);
        this.originOptions = options || {};
        this.options = this.getOptions(options);
        this.handleOptions();
        this.create();
    }

    getOptions(options) {
        const newOpt =  Object.assign({}, cloneDeep(INIT_OPTIONS), options);
        return newOpt;
    }
    getTarget(target) {
        return document.querySelector(target);
    }

    handleOptions() {
        if (typeof this.options.height !== 'undefined') {
            this.options.chart.height = this.options.height;
        }
        if (typeof this.options.categories !== 'undefined') {
            this.options.xaxis.categories = this.options.categories;
        }
        if (typeof this.options.yaxisTitle !== 'undefined') {
            this.options.yaxis.title.text = this.options.yaxisTitle;
        }
        if (typeof this.options.mainTitle !== 'undefined') {
            this.options.title.text = this.options.mainTitle;
        }
        if (typeof this.options.series !== 'undefined' && !this.options.colors) {
            this.options.colors = this.getBgColors(this.options.series.length);
        }
        if (typeof this.options.stacked !== 'undefined') {
            this.options.chart.stacked = this.options.stacked;
            this.handleOptionsStack();
        }
    }

    handleOptionsStack() {
        if (this.options.stacked) {
            this.options.legend = {
                position: 'bottom',
                horizontalAlign: 'center',
                offsetY: 5,
                markers:{
                    radius:'12'
                }
            };
            this.options.plotOptions.bar.dataLabels.position = 'center';
            this.options.dataLabels.offsetY = 0;
        }
    }

    getBgColors(colorNum) {
        /*const endIdx = colorNum < BG_COLORS.length ? colorNum : BG_COLORS.length -1;
        const result = [];
        for (let i=0; i<=endIdx; i++) {
            result.push(BG_COLORS[i]);
        }*/
        return BG_COLORS;
    }

    create() {
        this.plugin = new ApexCharts(this.targetObj, this.options);
    }

    destroy() {
        if (this.plugin) {
            this.plugin.destroy();
            this.plugin = null;
        }
    }

    render() {
        if (this.plugin) {
            this.plugin.render();
        }
    }

    refresh(options) {
        this.originOptions = Object.assign({}, this.originOptions, options)
        this.options = this.getOptions(this.originOptions);
        this.handleOptions();

        this.destroy();
        this.create();
        this.render();
    }
}

class ABChartColumn {
    core;
    constructor(target, options) {
        this.core = new ABChartColumnCore(target, options);
    }

    render() {
        this.core.render();
    }

    refresh(options) {
        this.core.refresh(options);
    }
}

window.ABChartColumn = ABChartColumn;

export default ABChartColumn;

/*
var optionsOLD = {
        series: [{
            name: 'Libero',
            data: [0, 17, 20, 1, 21, 2],
            //color: "#6BC1B4"
        }, {
            name: 'Opzionato',
            data: [1, 0, 0, 2, 0, 2],
            //color: "#9587C4",
        }],
        colors: ["#6BC1B4", "#9587C4"],
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        plotOptions: {
            bar: {
                horizontal: false,
                //borderRadius: 10
            },
        },
        dataLabels: {
            enabled: true,
//            formatter: function(val) {
//              return val + "%";
//            },
            //offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#cc0000"]
              }
          },
          xaxis: {
              //type: 'datetime',
              categories: [
                  'Monolocale',
                  'Bilocale',
                  'Trilocale',
                  'Ville a patio',
                  'Quadrilocale',
                  'Attici'
              ],
          },
          legend: {
              position: 'right',
              offsetY: 40
          },
          fill: {
              opacity: 1
          }
      };


*/